"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _zustand = _interopRequireDefault(require("zustand"));

var _constants = require("../constants");

var _selectors = require("../selectors");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _create = (0, _zustand["default"])(function (set, get) {
  return {
    // map loaded state
    loaded: false,
    setLoaded: function setLoaded(loaded) {
      return set({
        loaded: loaded
      });
    },
    // hovered feature state
    hoveredFeature: null,
    setHoveredFeature: function setHoveredFeature(hoveredFeature) {
      return set({
        hoveredFeature: hoveredFeature
      });
    },
    // selected feature state
    selectedFeature: null,
    setSelectedFeature: function setSelectedFeature(selectedFeature) {
      return set({
        selectedFeature: selectedFeature
      });
    },
    // default viewport state
    defaultViewport: _objectSpread({}, _constants.DEFAULT_VIEWPORT),
    setDefaultViewport: function setDefaultViewport(defaultViewport) {
      return set(function (state) {
        return {
          defaultViewport: defaultViewport,
          viewport: _objectSpread(_objectSpread({}, state.viewport), defaultViewport)
        };
      });
    },
    // current viewport state
    viewport: _constants.DEFAULT_VIEWPORT,
    setViewport: function setViewport(viewport) {
      return set(function (state) {
        var newViewport = _objectSpread(_objectSpread({}, state.viewport), viewport);

        return {
          viewport: newViewport
        };
      });
    },
    // helpers
    flyToFeature: function flyToFeature(feature) {
      var viewport = _objectSpread(_objectSpread({}, (0, _selectors.getViewportForFeature)(feature, get().viewport)), _constants.DEFAULT_FLIGHT_PROPS);

      set({
        viewport: viewport
      });
    },
    flyToBounds: function flyToBounds(bounds) {
      set(function (state) {
        return {
          viewport: _objectSpread(_objectSpread({}, (0, _selectors.getViewportForBounds)(bounds, state.viewport)), _constants.DEFAULT_FLIGHT_PROPS)
        };
      });
    },
    flyToLatLon: function flyToLatLon(lat, lon, zoom) {
      set(function (state) {
        return {
          viewport: _objectSpread(_objectSpread({}, state.viewport), {}, {
            latitude: lat,
            longitude: lon,
            zoom: zoom
          }, _constants.DEFAULT_FLIGHT_PROPS)
        };
      });
    },
    flyToState: function flyToState(stateId) {
      set(function (state) {
        return {
          viewport: _objectSpread(_objectSpread(_objectSpread({}, state.viewport), (0, _utils.getStateViewportByFips)(stateId, state.viewport)), _constants.DEFAULT_FLIGHT_PROPS)
        };
      });
    },
    flyToDefault: function flyToDefault() {
      set(function (state) {
        var newViewport = _objectSpread(_objectSpread(_objectSpread({}, state.viewport), state.defaultViewport), _constants.DEFAULT_FLIGHT_PROPS);

        return {
          viewport: newViewport
        };
      });
    }
  };
}),
    _create2 = _slicedToArray(_create, 1),
    useMapStore = _create2[0];

var _default = useMapStore;
exports["default"] = _default;